(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zerno-press-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__zpc)return; root.__zpc=true;
    var rail=root.querySelector('[data-zpc-rail]'), prog=root.querySelector('[data-zpc-prog]'),
        prev=root.querySelector('[data-zpc-prev]'), next=root.querySelector('[data-zpc-next]');
    if(!rail)return;
    function update(){
      var max=rail.scrollWidth-rail.clientWidth;
      if(prog){
        var ratio=rail.clientWidth/rail.scrollWidth;
        prog.style.width=Math.max(12,ratio*100)+'%';
        var pos=max>0?(rail.scrollLeft/max):0;
        var travel=prog.parentElement.clientWidth-prog.clientWidth;
        prog.style.transform='translateX('+(pos*travel)+'px)';
      }
      if(prev)prev.disabled=rail.scrollLeft<=2;
      if(next)next.disabled=rail.scrollLeft>=max-2;
    }
    function step(dir){
      var card=rail.firstElementChild;
      var w=card?card.getBoundingClientRect().width+16:300;
      rail.scrollBy({left:dir*w,behavior:'smooth'});
    }
    rail.addEventListener('scroll',update,{passive:true});
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
    window.addEventListener('resize',update);
    setTimeout(update,60);
  }
  function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-zpc]'),init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zerno-press-categories"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__zct)return; root.__zct=true;
    var rail=root.querySelector('[data-zct-rail]'), prog=root.querySelector('[data-zct-prog]'),
        prev=root.querySelector('[data-zct-prev]'), next=root.querySelector('[data-zct-next]');
    if(!rail)return;
    function update(){
      var max=rail.scrollWidth-rail.clientWidth;
      if(prog){
        var ratio=rail.clientWidth/rail.scrollWidth;
        prog.style.width=Math.max(12,ratio*100)+'%';
        var pos=max>0?(rail.scrollLeft/max):0;
        var travel=prog.parentElement.clientWidth-prog.clientWidth;
        prog.style.transform='translateX('+(pos*travel)+'px)';
      }
      if(prev)prev.disabled=rail.scrollLeft<=2;
      if(next)next.disabled=rail.scrollLeft>=max-2;
    }
    function step(dir){
      var t=rail.firstElementChild;
      var w=t?t.getBoundingClientRect().width+16:320;
      rail.scrollBy({left:dir*w,behavior:'smooth'});
    }
    rail.addEventListener('scroll',update,{passive:true});
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
    window.addEventListener('resize',update);
    setTimeout(update,60);
  }
  function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-zct]'),init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zerno-press-lineup"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__zpl)return; root.__zpl=true;
    var bars=root.querySelector('[data-zpl-bars]'); if(!bars)return;
    bars.addEventListener('click',function(e){
      var b=e.target.closest('button[data-i]'); if(!b)return;
      Array.prototype.forEach.call(bars.querySelectorAll('button'),function(x){x.classList.remove('is-on');});
      b.classList.add('is-on');
      var i=b.getAttribute('data-i');
      Array.prototype.forEach.call(root.querySelectorAll('[data-zpl-panel]'),function(p){
        p.classList.toggle('is-on',p.getAttribute('data-zpl-panel')===i);});
    });
  }
  function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-zpl]'),init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zerno-press-width"] && !Shopify.designMode) return;
  try {
    
(function(){
  var STEPS=[4,6,8,10,12],
      LBL={4:'Dainty',6:'Subtle',8:'Everyday',10:'Bold',12:'Statement'},
      NOTE={4:'Sits high and slim. Reads as jewellery rather than a statement, and layers under a heavier chain.',
            6:'The quiet daily option. Visible with a collar open, invisible under a tee.',
            8:'Present without shouting, and the one most people keep wearing.',
            10:'Real weight on the neck. This is the width people notice and comment on.',
            12:'Full statement. Heavy, wide, and the one that photographs.'};
  function svgChain(metal,lw){
    var id='w'+Math.random().toString(36).slice(2,8);
    var g=metal==='silver'?{a:'#eef1f4',b:'#8f99a3',hi:'#fff'}:{a:'#f0dfae',b:'#a5822f',hi:'#fff5da'};
    var W=400,H=400,cy=235,x1=132,x2=268,cx=200,ay=cy+54,
        p='M'+x1+' '+cy+' Q'+cx+' '+ay+' '+x2+' '+cy,l='',st=Math.max(.05,lw/260);
    for(var t=.06;t<=.94;t+=st){var mx=(1-t)*(1-t)*x1+2*(1-t)*t*cx+t*t*x2,my=(1-t)*(1-t)*cy+2*(1-t)*t*ay+t*t*cy;
      l+='<ellipse cx="'+mx.toFixed(1)+'" cy="'+my.toFixed(1)+'" rx="'+(lw*.5)+'" ry="'+(lw*.42)+'" fill="url(#'+id+')" stroke="rgba(0,0,0,.22)" stroke-width="1"/>';}
    return '<svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="xMidYMid slice"><defs><linearGradient id="'+id+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+g.a+'"/><stop offset=".5" stop-color="'+g.hi+'"/><stop offset="1" stop-color="'+g.b+'"/></linearGradient></defs>'
      +'<rect width="'+W+'" height="'+H+'" fill="#111"/>'
      +'<path d="M148 '+(cy-246)+' h104 v156 q0 42 -52 42 q-52 0 -52 -42 z" fill="#8d6647"/>'
      +'<ellipse cx="200" cy="'+(cy-246)+'" rx="56" ry="32" fill="#8d6647"/>'
      +'<path d="M0 '+(cy+42)+' q60 -80 132 -88 q68 45 136 0 q72 8 132 88 v'+H+' h-400 z" fill="#0a0a0b"/>'
      +'<path d="'+p+'" fill="none" stroke="url(#'+id+')" stroke-width="'+lw+'" stroke-linecap="round"/>'+l+'</svg>';
  }
  function init(root){
    if(root.__zpw)return; root.__zpw=true;
    var rg=root.querySelector('[data-zpw-range]'),fill=root.querySelector('[data-zpw-fill]'),
        tk=root.querySelector('[data-zpw-ticks]'),
        canvas=root.querySelector('[data-zpw-canvas]'),img=root.querySelector('[data-zpw-img]'),
        cnr=root.querySelector('[data-zpw-cnr]'),mmEl=root.querySelector('[data-zpw-mm]'),
        pz=root.querySelector('[data-zpw-pz]'),lbl=root.querySelector('[data-zpw-lbl]'),
        note=root.querySelector('[data-zpw-note]'),mts=root.querySelector('[data-zpw-metals]'),
        buy=root.querySelector('[data-zpw-buy]');
    var THUMB=24,metal='gold',fallback=root.getAttribute('data-fallback')||'#',
        most=parseInt(root.getAttribute('data-most'),10)||8;
    function pos(v){var p=(v-4)/8;return 'calc('+(THUMB/2)+'px + '+p+' * (100% - '+THUMB+'px))';}
    tk.innerHTML=STEPS.map(function(){return '<i></i>';}).join('');
    var tks=tk.querySelectorAll('i');
    STEPS.forEach(function(s,i){tks[i].style.left=pos(s);});
    STEPS.forEach(function(s){['gold','silver'].forEach(function(m){
      var u=root.getAttribute('data-i-'+m+'-'+s); if(u){var p=new Image();p.src=u;}});});
    function draw(){
      var v=+rg.value;
      mmEl.textContent=v;
      lbl.textContent=LBL[v];
      var real=root.getAttribute('data-p-'+metal+'-'+v);
      if(real){ pz.textContent=real; }
      else{
        var base=parseFloat(root.getAttribute('data-base'))||0,
            per=parseFloat(root.getAttribute('data-permm'))||0,
            cur=root.getAttribute('data-cur')||'$';
        pz.textContent = (base+per*v)>0 ? cur+Math.round(base+per*v) : '';
      }
      cnr.textContent=(metal==='gold'?'Gold':'White gold')+' '+v+'mm';
      note.innerHTML=(v===most?'<b>Our most ordered width.</b> ':'')+NOTE[v];
      if(buy){buy.textContent='Add '+v+'mm '+(metal==='gold'?'gold':'white gold');
        buy.setAttribute('href',root.getAttribute('data-u-'+metal+'-'+v)||fallback);}
      fill.style.width=pos(v);
      Array.prototype.forEach.call(tks,function(t,i){t.classList.toggle('is-on',STEPS[i]<=v);});
      var src=root.getAttribute('data-i-'+metal+'-'+v),old=canvas.querySelector('svg');
      if(src){ if(old)old.remove(); img.style.display=''; if(img.getAttribute('src')!==src)img.setAttribute('src',src); }
      else { img.style.display='none'; if(old)old.remove(); canvas.insertAdjacentHTML('beforeend',svgChain(metal,Math.max(8,v*2.2))); }
    }
    rg.addEventListener('input',draw);
    if(mts)mts.addEventListener('click',function(e){var b=e.target.closest('button[data-m]');if(!b)return;
      Array.prototype.forEach.call(mts.querySelectorAll('button'),function(x){x.classList.remove('is-on');});
      b.classList.add('is-on');metal=b.getAttribute('data-m');draw();});
    draw();
  }
  function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-zpw]'),init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
